// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2Gje-","alertIcon":"ConfirmModal_alertIcon__1o_lI"};